import { useEffect } from "react";
import "./embed.css";

export function Embed() {
  useEffect(() => {
    const script = document.createElement("script");
    // Updated Juicer script URL with per=1&pages=1 to limit posts and disable "Load More"
    script.src = "https://www.juicer.io/embed/minkara-combine-lab/embed-code.js?per=1&pages=1";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script); // Clean up on unmount
    };
  }, []);

  return (
    <div className="linkedInCont">
      <div className="shiny-row2">
        <div className="embed linkedin-embed">
          <ul className="juicer-feed" data-feed-id="minkara-combine-lab">
            <h1 className="title">Follow us @minkara-combine-lab</h1>
          </ul>
        </div>
      </div>
    </div>
  );
}
